var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
    fill: "#FEF3C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.293 7.293C12.1055 7.10545 11.8512 7.00006 11.586 7H8C7.73478 7 7.48043 7.10536 7.29289 7.29289C7.10536 7.48043 7 7.73478 7 8V11.586C7.00006 11.8512 7.10545 12.1055 7.293 12.293L11.645 16.645C11.8723 16.8708 12.1796 16.9976 12.5 16.9976C12.8204 16.9976 13.1277 16.8708 13.355 16.645L16.645 13.355C16.8708 13.1277 16.9976 12.8204 16.9976 12.5C16.9976 12.1796 16.8708 11.8723 16.645 11.645L12.293 7.293Z",
    stroke: "#D97706",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10C9.88807 10 10 9.88807 10 9.75C10 9.61193 9.88807 9.5 9.75 9.5C9.61193 9.5 9.5 9.61193 9.5 9.75C9.5 9.88807 9.61193 10 9.75 10Z",
    fill: "#D97706",
    stroke: "#D97706",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferIcon);
export default __webpack_public_path__ + "static/media/offer-icon.3d523248ed7483d9a5111a15f6e0c1fc.svg";
export { ForwardRef as ReactComponent };